"use client";
import ButtonCustom from "@modules/layout/components/button-custom";
import Accordion from "@modules/products/components/product-tabs/accordion";
import { useEffect, useRef, useState } from "react";

const ProductDescription = ({ description }: { description: string }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setIsOverflowing(contentRef.current.scrollHeight > 500);
    }
  }, [description]);

  const tabs = [
    {
      label: "Mô tả sản phẩm",
      component: (
        <div className="flex flex-col gap-0">
          <div
            ref={contentRef}
            className={`overflow-hidden transition-all duration-300 pb-4 whitespace-pre-line ${
              expanded ? "max-h-none" : "max-h-[500px]"
            }`}
            dangerouslySetInnerHTML={{
              __html: description || `<p>Không có mô tả</p>`,
            }}
          />
          {isOverflowing && (
            <div className="relative">
              {!expanded && (
                <div className="absolute bottom-10 left-0 w-full h-28 bg-gradient-to-t from-white via-white/90 to-transparent pointer-events-none"></div>
              )}
              <div className="flex justify-center items-center pb-2 relative z-10">
                <ButtonCustom variant="secondary" className="w-[100px]" onClick={() => setExpanded(!expanded)}>
                  {expanded ? "Thu gọn" : "Xem thêm"}
                </ButtonCustom>
              </div>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div
      //   className="content-container my-10 border border-[#E4E4EB] rounded-xl p-0 small:my-32"
      className="lg:content-container my-8 px-2"
      data-testid="related-products-container"
    >
      <Accordion type="multiple" defaultValue={tabs.map((tab) => tab.label)}>
        {tabs.map((tab, i) => (
          <Accordion.Item key={i} title={tab.label} headingSize="large" value={tab.label} customTrigger>
            {tab.component}
          </Accordion.Item>
        ))}
      </Accordion>
      {/* <div className="flex flex-col gap-4 p-5 pb-0">
        <Text className="font-semibold text-large">Mô tả sản phẩm</Text>
        <div
          ref={contentRef}
          className={`overflow-hidden transition-all duration-300 ${
            expanded ? "max-h-none" : "max-h-[500px]"
          }`}
          dangerouslySetInnerHTML={{
            __html: description || `<p>Không có mô tả</p>`,
          }}
        />
      </div>
      {isOverflowing && (
        <div className="relative">
          {!expanded && (
            <div className="absolute bottom-10 left-0 w-full h-28 bg-gradient-to-t from-white via-white/90 to-transparent pointer-events-none"></div>
          )}
          <div className="flex justify-center items-center pb-2 relative z-10">
            <ButtonCustom
              variant="secondary"
              className="w-[100px]"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Thu gọn" : "Xem thêm"}
            </ButtonCustom>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ProductDescription;
